module.exports = __webpack_public_path__ + "static/building-1080602_1920-4919975b67191309557f58f1acd2b361.jpg";